import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {
    MultiBalanceDto,
    ListResponse,
    ListMultiBalanceTransactionResponse,
    ListMultiBalanceTransactionRequest
} from "../http/protocol";



export class MultiBalanceService extends AbstractAdminEntityService<MultiBalanceDto, ListResponse> implements MultiBalanceService{

    constructor(http : HttpService) {
        super("/multibalance", http);
    }

    getBalances(userId:string, username: string):Promise<MultiBalanceDto[]> {
        return this.http.get(this.entityPath + "/balances?userId="+userId+"&username="+username);
    }

    getTransactionList(request:ListMultiBalanceTransactionRequest):Promise<ListMultiBalanceTransactionResponse> {
        return this.http.post(this.entityPath + "/transactions",request);
    }
    
}